<template>
  <input-autocomplete
    v-model="payload"
    :input-key="`${inputKey}${$t('app.reports.format.field')}`"
    :items="getFormats"
    required
    :label="$t('app.reports.format.field')"
  />
</template>

<script>
import InputAutocomplete from 'Support/components/inputs/InputAutocomplete.vue';

export default {
  name: 'FormatsAutocomplete',
  components: {
    InputAutocomplete,
  },
  props: {
    inputKey: {
      type: String,
      default: 'formatsAutocomplete',
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    getFormats() {
      return [this.$t('app.reports.format.formats.pdf'), this.$t('app.reports.format.formats.csv')];
    },
    payload: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
